import React, {createContext, useContext, useEffect, useState} from 'react';
import {getStats} from "../services/statsService";
import {getLastPredictions} from "../services/lastPredictionsService";
import {getGames} from "../services/gamesService";
import {getBasketGames} from "../services/bascketService";
import {getTennisGames} from "../services/tennisService";
import {getHighOddsGames} from "../services/highOddsService";
import {getHighOddsAIGames} from "../services/highOddsAIService";

export const DataContext = createContext();

export const useData = () => {
  return useContext(DataContext);
};

export const DataProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false);
  const [games, setGames] = useState(null);
  const [stats, setStats] = useState(null);
  const [lastPredictions, setLastPredictions] = useState(null);
  const [highOddsGames, setHighOddsGames] = useState(null);
  const [highOddsAIGames, setHighOddsAIGames] = useState(null);
  const [bascketGames, setBascketGames] = useState(null);
  const [tennisGames, setTennisGames] = useState(null);
  const [errorStats, setErrorStats] = useState(null);

  useEffect(() => {
    if(loaded){
      return ;
    }

    // ----- Fetch STATS -----
    if (!stats) {
      getStats()
          .then((data) => {
            setStats(data);
            setLoaded(true);
          })
          .catch((err) => {
            console.error(err);
            setLoaded(true);
          });
    }

    // ----- Fetch LAST PREDICTIONS -----
    if (!lastPredictions) {
      getLastPredictions()
          .then((data) => {
            setLastPredictions(data);
          })
          .catch((err) => console.error(err));
    }

    // ----- Fetch GAMES (Normal Odds) -----
    if (!games) {
      getGames()
          .then((fetchedGames) => {
            setGames(fetchedGames);
          })
          .catch((err) => console.error(err));
    }

    // ----- Fetch BASKET GAMES -----
    if (!bascketGames) {
      getBasketGames()
          .then((fetchedGames) => {
            setBascketGames(fetchedGames);
          })
          .catch((err) => console.error(err));
    }

    // ----- Fetch TENNIS GAMES -----
    if (!tennisGames) {
      getTennisGames()
          .then((fetchedGames) => {
            setTennisGames(fetchedGames);
          })
          .catch((err) => console.error(err));
    }

    // ----- Fetch HIGH ODDS GAMES -----
    if (!highOddsGames) {
      getHighOddsGames()
          .then((data) => {
            setHighOddsGames(data);
          })
          .catch((err) => console.error(err));
    }

    // ----- Fetch HIGH ODDS AI GAMES -----
    if (!highOddsAIGames) {
      getHighOddsAIGames()
          .then((data) => {
            setHighOddsAIGames(data);
          })
          .catch((err) => console.error(err));
    }

      setErrorStats(null)
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  return (
    <DataContext.Provider value={{ games, setGames,stats, setStats,lastPredictions,
      setLastPredictions,highOddsGames,setHighOddsGames,highOddsAIGames,setHighOddsAIGames,bascketGames,setBascketGames,
      tennisGames,setTennisGames, loaded, errorStats}}>
      {children}
    </DataContext.Provider>
  );
};